import { ITokenStorage } from 'modules/core/domain/interfaces/i-token-storage';
import { TokenStorage } from 'modules/core/token-storage';
import { AuthRequestAuthCodePayload } from '../interfaces/auth-request-auth-code-payload';
import { AuthSignInPayload } from '../interfaces/auth-sign-in-payload';
import { AuthCheckResponse, AuthSignInResponse } from '../interfaces/auth-sign-in-response';
import { AuthSignUpPayload } from '../interfaces/auth-sign-up-payload';
import { AuthSignUpResponse } from '../interfaces/auth-sign-up-response';
import authResource from '../resources/auth-resource';

class AuthService {
  constructor(private readonly tokenStorage: ITokenStorage) {}

  public async check(): Promise<AuthCheckResponse | null> {
    const previousToken = this.getToken();
    if (!previousToken) {
      return null;
    }

    this.saveToken(previousToken);

    try {
      const [tournament, user] = await Promise.all([
        await authResource.getAvailableTournaments({ limit: 1 }),
        await authResource.check(),
      ]);

      return { user, tournament: tournament[0] ?? undefined };
    } catch (error) {
      console.error('Check auth error:', error);
      return null;
    }
  }

  public async requestAuthCode(data: AuthRequestAuthCodePayload): Promise<void> {
    await authResource.requestAuthCode(data);
  }

  public async signIn(data: AuthSignInPayload): Promise<AuthSignInResponse['user']> {
    const response = await authResource.signIn(data);
    this.saveToken(response.token);
    return response.user;
  }

  public signOut() {
    this.removeToken();
    return null;
  }

  public async signUp(data: AuthSignUpPayload): Promise<AuthSignUpResponse> {
    return await authResource.signUp(data);
  }

  private saveToken(token: string): void {
    this.tokenStorage.saveToken(token);

    authResource.resource.setHeaders({
      Authorization: `Bearer ${token}`,
    });
  }

  private getToken() {
    return this.tokenStorage.getToken();
  }

  private removeToken() {
    this.tokenStorage.removeToken();
  }
}

const authService = new AuthService(new TokenStorage());
export default authService;
